import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { ResizeAF } from '../../utils/ResizeAF';
import Event from '../../utils/Event';

const template = `
<div class="gallery2" :class='mainClass'>
  <div class='gallery2__list' :style="{'height': slotHeight}">
    <div class="gallery2__item"
      v-for='(key, k) in slotKeys'
      :class='{"gallery2__item--active": current == k}'
      :key="key"
      :ref="key"
    >
       <slot :name="key"></slot>
    </div>
  </div>
</div>
`;

@Component({
  template: template
})
export default class Gallery2 extends Vue {
  @Prop({ default: '' }) mainClass!: string;

  current = 0;
  slotHeight = '0px';
  private timerId?: any;
  private restartTimerId?: any;

  get slotKeys() {
    return Object.keys(this.$slots)
  }

  @Watch('current')
  onCurrentChange() {
    this.$nextTick(() => {
      this.setSlotHeight();
    });
  }

  mounted(): void {
    this.$nextTick(() => {
      this.setSlotHeight();
    });

    ResizeAF.instance().on(() => {
      this.setSlotHeight();
    });

    ResizeAF.instance().trigger();

    Event.listen('next-slide', this.showNext);
    Event.listen('prev-slide', this.showPrev);
    Event.listen('stop-slider', this.stop);
    Event.listen('start-slider', this.start);
    Event.listen('adjust-slider', this.setSlotHeight);

    this.start();
  }

  onMouseOver() {
    // this.stop();
  }

  onMouseLeave() {
    // if (!MD.mobile()) {
    //   this.start();
    // }
  }

  _next(): void {
    this.current = this.current >= this.slotKeys.length - 1 ? 0 : this.current + 1;
    Event.fire('close-quotes');
  }

  _prev(): void {
    this.current = this.current == 0 ? this.slotKeys.length - 1 : this.current - 1;
    Event.fire('close-quotes');
  }

  showNext() {
    this.stop();
    this._next();
    this._startIn();
  }

  showPrev() {
    this.stop();
    this._prev();
    this._startIn();
  }

  _startIn() {
    if (this.restartTimerId) {
      clearTimeout(this.restartTimerId);
    }

    this.restartTimerId = setTimeout(() => {
      this.start();
    }, 30000);
  }

  start() {
    this.timerId = setInterval(this._next, 20000);
  }

  stop() {
    console.log('stop');
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  }

  private setSlotHeight() {
    requestAnimationFrame(() => {
      try {
        const key = this.slotKeys[this.current] + '';
        // @ts-ignore
        const el = <HTMLElement>(this.$refs[`${key}`][0]);
        this.slotHeight = `${el.clientHeight}px`;
      } catch (e) {
        this.slotHeight = `0px`;
      }
    });
  }
}
